export const SWIPE_VELOCITY = 0.2;
export const DISMISS_THRESHOLD_PX = 18;
export const MOBILE_DISMISS_THRESHOLD_VH = 10;
export const SWIPE_ROW_THRESHOLD_PX = 44;
export const FLOOR_SWIPE_THRESHOLD_PX = 48;
